import {
    Button,
    Flex,
    Heading,
    HStack,
    PinInput,
    PinInputField,
    Spinner,
    Text,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VerifyContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { backbtn } from './dashboard/components/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { clearReq, verifyUser } from '../redux/actions/authActions';
import { useScreenWidth } from 'hooks/useScreenWidth';

const SignupVerification = () => {
    const [otp, setOtp] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const screen = useScreenWidth();
    const regReducer = useSelector((state) => state.regReducer);
    const verifyReducer = useSelector((state) => state.verifyReducer);
    const { user, userData } = regReducer;
    const { verifiedUser, loading } = verifyReducer;
    // console.log({ verifiedUser });
    let request_id = user?.data?.request_id;

    useEffect(() => {
        if (!request_id) {
            navigate(`/login`);
        }
    }, [navigate, request_id]);

    useEffect(() => {
        const access_token = localStorage.getItem('access_token');
        if (verifiedUser && access_token) {
            // navigate(`../choose-category`);
            navigate(screen > 500 ? '/dashboard/actions' : '/actions', {
                replace: true,
            });
        }
        if (!loading) {
            setOtp('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [verifiedUser, navigate, loading]);

    const handleSubmit = () => {
        if (request_id) {
            let data = {
                request_id,
                otp,
            };
            dispatch(verifyUser(data));
        }
    };
    const handleBack = () => {
        navigate(-1);
        dispatch(clearReq());
    };

    return (
        <VerifyContainer>
            <HStack
                justify="space-between"
                px="27px"
                alignItems="center"
                onClick={handleBack}
                display={{ base: 'flex', lg: 'none' }}>
                <span>{backbtn}</span>
                <div className="menuSection"></div>
            </HStack>
            <Flex
                w={{ base: 'full', lg: '450px' }}
                mt={{ base: 'o', lg: '120px' }}
                h="full"
                boxSizing="border-box"
                mx={{ base: 'auto' }}
                p={{ base: '0', lg: '45px 24px' }}
                justify="center"
                alignItems="center"
                border={{ base: 'none', lg: '1px solid #F2F4F5' }}
                flexDir="column">
                <Heading
                    as="h2"
                    w="90%"
                    mt="25px"
                    mb="26px"
                    textAlign={{ base: 'left', lg: 'center' }}
                    color="#090A0A"
                    fontSize="32px"
                    lineHeight="36px">
                    Thanks for Signing Up, Please Check your Mail{' '}
                </Heading>
                <Text w="90%" textAlign={{ base: 'left', lg: 'center' }}>
                    Enter the 4-digit that we have sent via the email <b>{userData?.email}</b>
                </Text>

                <HStack mt="52px" gap="14px" fontSize="16px" lineHeight="24px">
                    <PinInput
                        required
                        otp
                        value={otp}
                        type="alphanumeric"
                        placeholder="-"
                        onChange={(value) => setOtp(value)}>
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                        <PinInputField
                            borderRadius="50%"
                            border="1px solid #e3e5e6"
                            _focus={{ borderColor: '#6b4eff' }}
                            w="50px"
                            h="50px"
                            color="#090A0A"
                            fontSize="16px"
                            inputMode="numeric"
                        />
                    </PinInput>
                </HStack>

                <Button disabled={otp.length !== 4 || loading} w="90%" onClick={handleSubmit}>
                    {loading ? <Spinner color="white" size="sm" /> : 'Get Started'}
                </Button>

                <Text color="" fontSize="13px" mt="2rem" fontWeight="500">
                    <b>Note: </b>Check Your Inbox or Spam Folder for OTP code
                </Text>
            </Flex>
        </VerifyContainer>
    );
};

export default SignupVerification;
